<template>
  <div>
    <Dropdown>
      <template v-slot:dropdown-button>
        <button
          type="button"
          class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
          id="options-menu"
          aria-haspopup="true"
          aria-expanded="true"
        >
          Send Message
          <svg
            class="-mr-1 ml-2 h-5 w-5"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fill-rule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      </template>
      <template v-slot:dropdown-content>
        <div v-if="!isInShopifyMobileApp" class="py-1">
          <a
            v-for="template in orderTemplates"
            :key="template.id"
            class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
            role="menuitem"
            @click="itemClicked(template)"
            >{{ template.name }}
          </a>
        </div>
        <div v-if="isInShopifyMobileApp" class="py-1">
          <a
            v-for="template in orderTemplates"
            :key="template.id"
            :href="getWhatsappHref(template)"
            class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
            role="menuitem"
            @click="handleHrefClick(template)"
            target="_blank"
            >{{ template.name }}
          </a>
        </div>
        <div class="relative">
          <div class="absolute inset-0 flex items-center" aria-hidden="true">
            <div class="w-full border-t border-gray-300"></div>
          </div>
        </div>
        <a
          class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          role="menuitem"
          target="_blank"
          @click="gotoTemplatesPage()"
          >Add / Translate Template
        </a>
      </template>
    </Dropdown>
    <PlanExceededModal v-if="isPlanExceeded" @close="isPlanExceeded = false" />
  </div>
</template>

<script>
import Dropdown from "./Dropdown.vue";

import PlanExceededModal from "./PlanExceededModal";
import crispNudgeMixin from "../../Mixins/crispNudgeMixin";

import Helpers from "../../Mixins/helpers";

export default {
  components: {
    Dropdown,
    PlanExceededModal
  },
  data() {
    return {
      isOpen: false,
      isPlanExceeded: false
    };
  },
  mixins: [Helpers, crispNudgeMixin],
  props: {
    order: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    orderTemplates() {
      return this.$store.getters.getOrderTemplates;
    },
    isInShopifyMobileApp() {
      // eslint-disable-next-line
      return shopify.environment.mobile;
    }
  },
  created() {},
  beforeDestroy() {},
  methods: {
    getShopUrlFromOrderStatusUrl(url) {
      const myURL = new URL(url);
      return myURL.origin;
    },
    getOrderItems() {
      let result = "";
      if (this.order.lineItems && this.order.lineItems.length > 0) {
        this.order.lineItems.forEach((lineItem) => {
          result += `${lineItem.name} x ${lineItem.quantity}\n`;
        });
      }
      return result;
    },
    gotoTemplatesPage() {
      this.$router.push({ name: "Templates" });
    },
    async itemClicked(template) {
      const store = this.$store.getters.getStore;
      if (store && store.hasOldBillingEnabled === false) {
        const response = await this.$store.dispatch("checkUsageLimit");
        if (response && response.canSend === false) {
          console.log("exceeded limit");
          this.isPlanExceeded = true;
          this.isOpen = false;
          return;
        }
        if (store.plan === "vip" || store.plan === "advanced") {
          if (store.manualMessageSent < 100) {
            this.$store.dispatch("updateUsageLimit");
          }
        } else {
          this.$store.dispatch("updateUsageLimit");
        }
      }

      this.$emit("onItemClicked", template);

      const message = this.getWhatsappLink(template);
      window.open(message, "_new");
      this.$store.dispatch("updateOrder", {
        requestParams: {
          isMessageSent: true,
          templateName: template.name
        },
        orderId: this.order.id
      });

      if (
        store.sendMessagesUsingDesktopApp &&
        store.shouldDoDblClickForDesktop
      ) {
        this.doDoubleClickForDesktop(message);
      }
    },
    doDoubleClickForDesktop(link) {
      setTimeout(() => {
        window.open(link, "_new");
      }, 100);
    },
    getWhatsappLink(template) {
      const store = this.$store.getters.getStore;
      let phoneNumber = this.order.customer.phoneNumber.replace(
        /[^a-zA-Z0-9]/g,
        ""
      );
      if (phoneNumber.startsWith("440")) {
        phoneNumber = phoneNumber.replace("440", "44");
      }
      // if (phoneNumber.startsWith("1849") ) {
      //   phoneNumber = phoneNumber.replace("1849", "1");
      // }
      if (phoneNumber.startsWith("1849809")) {
        phoneNumber = phoneNumber.replace("1849809", "1809");
      }
      if (phoneNumber.startsWith("1849849")) {
        phoneNumber = phoneNumber.replace("1849849", "1849");
      }
      if (phoneNumber.startsWith("1849829")) {
        phoneNumber = phoneNumber.replace("1849829", "1829");
      }
      if (phoneNumber.startsWith("18491809")) {
        phoneNumber = phoneNumber.replace("18491809", "1809");
      }
      if (phoneNumber.startsWith("1868868")) {
        phoneNumber = phoneNumber.replace("1868868", "1868");
      }
      if (phoneNumber.startsWith("18681868")) {
        phoneNumber = phoneNumber.replace("18681868", "1868");
      }
      if (phoneNumber.startsWith("270")) {
        phoneNumber = phoneNumber.replace("270", "27");
      }
      if (phoneNumber.startsWith("11")) {
        phoneNumber = phoneNumber.replace("11", "1");
      }

      if (phoneNumber.startsWith("+600")) {
        phoneNumber = phoneNumber.replace("+600", "+60");
      }
      if (phoneNumber.startsWith("5656")) {
        phoneNumber = phoneNumber.replace("5656", "56");
      }
      if (phoneNumber.startsWith("9720")) {
        phoneNumber = phoneNumber.replace("9720", "972");
      }
      if (phoneNumber.startsWith("97100971")) {
        phoneNumber = phoneNumber.replace("97100971", "971");
      }
      if (phoneNumber.startsWith("9710971")) {
        phoneNumber = phoneNumber.replace("9710971", "971");
      }
      if (phoneNumber.startsWith("9710")) {
        phoneNumber = phoneNumber.replace("9710", "971");
      }
      if (phoneNumber.startsWith("5980")) {
        phoneNumber = phoneNumber.replace("5980", "598");
      }
      if (phoneNumber.startsWith("9191")) {
        phoneNumber = phoneNumber.replace("9191", "91");
      }
      if (phoneNumber.startsWith("96600966")) {
        phoneNumber = phoneNumber.replace("96600966", "966");
      }
      if (phoneNumber.startsWith("9660")) {
        phoneNumber = phoneNumber.replace("9660", "966");
      }
      if (phoneNumber.startsWith("520")) {
        phoneNumber = phoneNumber.replace("520", "52");
      }
      if (phoneNumber.startsWith("320032")) {
        phoneNumber = phoneNumber.replace("320032", "32");
      }

      if (phoneNumber.startsWith("97400974")) {
        phoneNumber = phoneNumber.replace("97400974", "974");
      }
      if (phoneNumber.startsWith("97100971")) {
        phoneNumber = phoneNumber.replace("97100971", "971");
      }
      if (phoneNumber.startsWith("96500965")) {
        phoneNumber = phoneNumber.replace("96500965", "965");
      }
      if (phoneNumber.startsWith("966966")) {
        phoneNumber = phoneNumber.replace("966966", "966");
      }
      if (phoneNumber.startsWith("920")) {
        phoneNumber = phoneNumber.replace("920", "92");
      }
      if (phoneNumber.startsWith("52") && !phoneNumber.startsWith("521")) {
        phoneNumber = phoneNumber.replace("52", "521");
      }

      const firstName = this.order.customer.firstName
        ? this.order.customer.firstName
        : "";

      let body = template.body.replace("{firstName}", firstName);

      const lastName = this.order.customer.lastName
        ? this.order.customer.lastName
        : "";

      body = body.replace("{lastName}", lastName);
      body = body.replace("{orderId}", this.order.orderNumber);
      body = body.replace(
        "{shopUrl}",
        this.getShopUrlFromOrderStatusUrl(this.order.orderStatusUrl)
      );
      body = body.replace("{orderStatusUrl}", this.order.orderStatusUrl);
      body = body.replace("{orderItems}", this.getOrderItems());
      body = body.replace(
        "{totalAmount}",
        `${this.order.currency} ${this.order.totalPrice}`
      );
      body = body.replace("{trackingNumber}", `${this.order.trackingNumber}`);
      body = body.replace("{trackingUrl}", `${this.order.trackingUrl}`);
      if (this.order.shippingAddress) {
        body = body.replace(
          "{shippingAddress}",
          `${this.order.shippingAddress}`
        );
      }
      let link = `https://web.whatsapp.com/send`;
      if (this.isMobile()) {
        link = `https://api.whatsapp.com/send`;
      }

      if (store.id === "64ec7fe4412ebff58f5c2935") {
        const secret = this.getParameterByName(
          "key",
          this.order.orderStatusUrl
        );
        const url = `https://shopfiona.com/60194029720/order_payment/${this.order.orderId}?secret=${secret}`;
        body = body.replace("{prepaidUrl}", url);
      }

      body = encodeURIComponent(body);

      if (store.sendMessagesUsingDesktopApp && !this.isMobile()) {
        link = "whatsapp://send";
      }

      // link = "whatsapp://send";

      const message = `${link}/?phone=${phoneNumber}&text=${body}&source&data&app_absent`;
      return message;
    },
    getParameterByName(name, url) {
      // eslint-disable-next-line
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    getWhatsappHref(template) {
      const message = this.getWhatsappLink(template);
      return message;
    },
    handleHrefClick(template) {
      this.isOpen = false;
      this.$store.dispatch("updateOrder", {
        requestParams: {
          isMessageSent: true,
          templateName: template.name
        },
        orderId: this.order.id
      });
    },
    handleOutsideClick(e) {
      // close dropdown when clicked outside
      if (!this.$el.contains(e.target)) {
        this.dropDropdown = false;
        this.isOpen = false;
      }
    },
    showSendMessageHelpNudge() {
      this.showCrispNudge({
        key: "send_message_dropdown_help",
        text: "Need help in customizing the message template",
        cooldownMs: 0, // Always show the message by setting cooldown to 0
        scopeToRoute: true,
        sendAsMessage: true
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
